import { api } from "../Configurations/axios";

const GetAllExternalEmailsByTenantAPI = async (tenantId: string) => {
    try {
        var result = await api.get(`/finepNotification/GetAllExternalEmailsByTenant/${tenantId}`);
        var response = result.data;
        return response;

    } catch (error: any) {
        throw new Error(error.response.data);
    }
}


const PostNotification = async (registerId: string, cardName: string, tabName: string, observation: string, emailList: string[]) => {
    try {
        const result = await api.post('/finepNotification/SendNotification', {
            registerId: registerId,
            cardName: cardName,
            tabName: tabName,
            observation: observation,
            emailList: emailList
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetAllExternalEmailsByTenantAPI,
    PostNotification
}